import { render, staticRenderFns } from "./ItemSizeSelector.vue?vue&type=template&id=1ff45660&scoped=true&"
import script from "./ItemSizeSelector.vue?vue&type=script&lang=js&"
export * from "./ItemSizeSelector.vue?vue&type=script&lang=js&"
import style0 from "./ItemSizeSelector.vue?vue&type=style&index=0&id=1ff45660&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff45660",
  null
  
)

export default component.exports